export default "__VITE_ASSET__DuuqQ6gQ__"